import UploadFile from './pages/UploadFile'

const router = {
  name: 'uploadFile',
  path: 'uploadfile',
  component: UploadFile,
  props: true,
  meta: {
    showMenu: false,
    requiresAuth: true,
    requiresPermission: true,
    action: 77,
    titleHeader: 'Carga de documentos'
  }
}

export default router
